import {
  Directive,
  EmbeddedViewRef,
  Input,
  OnDestroy,
  TemplateRef,
  ViewContainerRef,
  effect,
} from '@angular/core';
import { UserPermissionsService } from '@shared/services/user-permissions.service';

type RoleInput = string | string[] | null | undefined;

@Directive({ selector: '[hasRole]', })
export class HasRoleDirective implements OnDestroy {
  private requiredRoles: string[] = [];
  private requireAll = false;
  private viewRef: EmbeddedViewRef<unknown> | null = null;

  constructor(
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef,
    private userPermissionsService: UserPermissionsService,
  ) {
    effect(() => {
      this.userPermissionsService.rolesSet();
      this.updateView();
    });
  }

  @Input() set hasRole(value: RoleInput) {
    this.requiredRoles = this.normalize(value);
    this.updateView();
  }

  @Input() set hasRoleMode(mode: 'any' | 'all') {
    this.requireAll = mode === 'all';
    this.updateView();
  }

  ngOnDestroy(): void {
    this.viewContainer.clear();
    this.viewRef = null;
  }

  private normalize(value: RoleInput): string[] {
    if (!value) return [];
    return Array.isArray(value) ? value.filter(Boolean) : [value];
  }

  private updateView(): void {
    const allowed = this.requiredRoles.length === 0
      ? true
      : this.requireAll
        ? this.userPermissionsService.hasAllRoles(this.requiredRoles)
        : this.userPermissionsService.hasAnyRole(this.requiredRoles);

    if (allowed && !this.viewRef) {
      this.viewRef = this.viewContainer.createEmbeddedView(this.templateRef);
    } else if (!allowed && this.viewRef) {
      this.viewContainer.clear();
      this.viewRef = null;
    }
  }
}
